// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CaixaVendasDaTela_LimpaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /cli/Caixa_vendas_da_tela/limpa (chamado New Shoes 2026-0065).
 *
 * default 'dry-run': um POST sem corpo NUNCA escreve. O `apply` exclui lançamentos de
 * caixa em produção e refaz saldos — só depois de alguém ler o dry-run.
 */
import { registerContract } from './validate'

export interface CaixaVendasDaTela_LimpaInput {
mode?: string
}

registerContract('CaixaVendasDaTela_LimpaInput', {
  mode: { type: 'string',  required: false },
})
